import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('Sub 계정 리스트 조회', v10APIs),
    mergeVersionsByTitle('메이크샵 전용 온라인상품 등록', v10APIs),
    mergeVersionsByTitle('온라인상품 등록 (WAKE-UP)', v10APIs),
    mergeVersionsByTitle('온라인상품 조회 (WAKE-UP)', v10APIs),
    mergeVersionsByTitle('회원 조회 (WAKE-UP)', v10APIs),
    mergeVersionsByTitle('표준카테고리 리스트 엑셀 갱신 (EMP)', v10APIs),
    mergeVersionsByTitle('회원 가입', v10APIs),
    mergeVersionsByTitle('회원 정보 수정', v10APIs),
    mergeVersionsByTitle('회원 탈퇴', v10APIs),
  ].filter(Boolean);

  return { title: '기타', children };
};

export default data;
